import { __rest } from "tslib";
/**
 * @desc 支持Row展示时分配各个Col的占比 （目前均为单行搜索栏，如有需求可以拓展至多行Col占比）
 * @props layoutArr       number[]    占比数组  组件children按照此数组中的值进行占比
 * @props gutter?         number      Col之间的空隙，默认16
 * @props style?          object      样式
 * @props className?      string      类名
 * @props ...restProps?   any         可以传antd组件里的属性 如 type justify align 如传antd不支持的属性会报错
 */
import React, { Component } from 'react';
import { Row, Col } from 'antd';
import { judgeArr } from '@/shared/functions';
class RowLayout extends Component {
    constructor() {
        super(...arguments);
        this.dealCol = () => {
            const { layoutArr, children } = this.props;
            // layoutArr 的每一个值 对应一个child
            if (children && judgeArr(layoutArr)) {
                const layoutArrLen = layoutArr.length;
                const childrenLen = React.Children.count(children);
                const childrenArr = React.Children.toArray(children);
                // 增加容错 即 如果有children，childrenLen < layoutArrLen时，依据childrenLen切割layoutArr
                if (childrenLen > 0 && childrenLen <= layoutArrLen) {
                    const dealLayoutArr = layoutArr.slice(0, childrenLen);
                    return (<>
              {dealLayoutArr.map((item, index) => (<Col key={`Col${index}`} span={item}>{childrenArr[index]}</Col>))}
            </>);
                }
            }
            return null;
        };
    }
    render() {
        const _a = this.props, { gutter = 16, style, className, layoutArr } = _a, restProps = __rest(_a, ["gutter", "style", "className", "layoutArr"]);
        return (<Row gutter={gutter} style={style} className={className} {...restProps}>
        {this.dealCol()}
      </Row>);
    }
}
export default RowLayout;
